module.exports = __webpack_public_path__ + "static/img/11.be0880e7.jpg";